import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/physiotherapyIndeces',
  	  method: 'get',
      params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/physiotherapyIndeces/inventory',
      method: 'get',
      params
    })
  }
  export function show(id) {
    return request({
      url: `/physiotherapyIndeces/${id}`,
      method: 'get'
    })
  }
  export function store(data) {
    return request({
      url: '/physiotherapyIndeces',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/physiotherapyIndeces/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/physiotherapyIndeces/${id}`,
      method: 'delete',
    })
  }
